import type { User, UserFormType, UserListItem } from '@/types'
import { UserRoleCodes } from '@/types'

import Model from './Model'

type FormType = UserFormType
type ListItemType = UserListItem
type SingleType = User

type Type = FormType | ListItemType | SingleType

export default class UserModel extends Model {
  static model: FormType = {
    name: null,
    email: null,
    role_name: UserRoleCodes.Administrator,
    password: null,
  }

  static get() {
    return super.get() as FormType
  }

  static prepareWith<T = Type>(model: T) {
    return super.prepareWith(model) as FormType
  }

  static reset<F = Type, S = Type>(formModel: F, snapshot?: S) {
    return super.reset(formModel, snapshot) as F & S
  }

  static mergeTogether<T = Type>(model: T) {
    return super.mergeTogether(model) as Type
  }

  static mergeTogetherAndCutExcess<T = Type>(model: T) {
    return super.mergeTogetherAndCutExcess(model) as FormType
  }

  static onlyModelKeysDiff<T = Type>(snapshot: T, formModel: T) {
    return super.onlyModelKeysDiff(snapshot, formModel) as Partial<FormType>
  }
}
